import React from 'react';
import { RiErrorWarningLine } from 'react-icons/ri';

/**
 * แถบแจ้งว่าโหลดรายการไม่สำเร็จ + ปุ่มลองใหม่ (KD3 S2113 · BUG-S2113-001)
 * เดิมหน้าโครงการ/ซิม/แพ็กเกจซิม/ผู้ลงนาม/ประเภทอุปกรณ์ ไม่อ่าน error ของ query เลย →
 * backend ล่มแล้วจอขึ้น "ไม่มีข้อมูล" (หน้าโครงการบอกว่า "ยังไม่มีข้อมูลโครงการในระบบ — เพิ่มโครงการแรก")
 * ผู้ใช้จึงเข้าใจว่าข้อมูลหาย · แบบเดียวกับที่หน้าบริษัท/สินค้า/อุปกรณ์แสดงอยู่แล้ว
 */
interface ListLoadErrorBannerProps {
  error: unknown;
  entityLabel: string;
  onRetry: () => void;
}

export const listLoadErrorMessage = (error: unknown, entityLabel: string): string => {
  const status = (error as any)?.response?.status;
  if (!status) {
    return `ไม่สามารถโหลดข้อมูล${entityLabel}ได้ — เชื่อมต่อเซิร์ฟเวอร์ไม่ได้ กรุณาตรวจสอบการเชื่อมต่อแล้วลองใหม่`;
  }
  if (status === 403) {
    return `คุณไม่มีสิทธิ์ดูข้อมูล${entityLabel}`;
  }
  return `ไม่สามารถโหลดข้อมูล${entityLabel}ได้ — เซิร์ฟเวอร์ขัดข้อง (${status}) กรุณาลองใหม่อีกครั้ง`;
};

const ListLoadErrorBanner: React.FC<ListLoadErrorBannerProps> = ({ error, entityLabel, onRetry }) => {
  if (!error) return null;
  return (
    <div role="alert" className="mb-4 flex items-start gap-3 p-4 border border-danger-200 rounded-xl bg-danger-50">
      <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-danger-100 flex items-center justify-center">
        <RiErrorWarningLine className="w-4 h-4 text-danger-500" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-danger-800">{listLoadErrorMessage(error, entityLabel)}</p>
        <button
          type="button"
          className="mt-1.5 text-xs font-medium text-danger-600 hover:text-danger-700 underline focus:outline-none"
          onClick={onRetry}
        >
          ลองใหม่อีกครั้ง
        </button>
      </div>
    </div>
  );
};

export default ListLoadErrorBanner;
